import { render, staticRenderFns } from "./FirstPage.vue?vue&type=template&id=9cb8172c&scoped=true"
import script from "./FirstPage.vue?vue&type=script&lang=js"
export * from "./FirstPage.vue?vue&type=script&lang=js"
import style0 from "./FirstPage.vue?vue&type=style&index=0&id=9cb8172c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb8172c",
  null
  
)

export default component.exports